import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import numeral from "numeral";

import "./Channel.css";
import request from "../../api";

const Channel = ({ channelId }) => {
  const [channelDetails, setChannelDetails] = useState(null);

  useEffect(() => {
    if (channelId) {
      const get_channel_details = async () => {
        const {
          data: { items },
        } = await request("/channels", {
          params: {
            part: "snippet,statistics",
            id: channelId,
          },
        });

        setChannelDetails(items[0]);
      };
      get_channel_details();
    }
  }, [channelId]);

  return (
    <Row className="m-1 py-3">
      <Col xs={6} md={3} className="channel-thumbnail">
        <LazyLoadImage
          src={channelDetails?.snippet?.thumbnails?.default?.url}
          effect="blur"
          className="rounded-circle "
        />
      </Col>
      <Col xs={6} md={9}>
        <h5 className="mb-1">{channelDetails?.snippet?.title}</h5>
        <div className="mb-2">
          <span>
            {numeral(channelDetails?.statistics?.subscriberCount).format("0.a")}{" "}
            subscribers | &nbsp;
            {channelDetails?.statistics?.videoCount} videos
          </span>
        </div>
        <div className="channel-desc">
          {channelDetails?.snippet?.description}
        </div>
      </Col>
    </Row>
  );
};

export default Channel;
